import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthnService } from '../../../services/authn.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-set-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.css']
})
export class SetPasswordComponent implements OnInit {
  static readonly PASSWORD_PATTERN = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^\\w\\s]).{12,}$';

  passwordForm: FormGroup;
  token: string | null = null;
  message: string = '';

  constructor(private formBuilder: FormBuilder, public authnService: AuthnService, public router: Router,
    private route: ActivatedRoute, private messageService: MessageService) {
    this.passwordForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.pattern(SetPasswordComponent.PASSWORD_PATTERN)]],
        confirmPassword: ['', [Validators.required, Validators.pattern(SetPasswordComponent.PASSWORD_PATTERN)]]
      }, { validators: SetPasswordComponent.passwordsMatch });
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (!this.token) {
      this.message = 'This link is invalid: no token was provided';
    }
  }

  static passwordsMatch(group: FormGroup): { [key: string]: boolean } | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return (password === confirmPassword) ? null : { 'mismatch': true };
  }

  setPassword() {
    if (this.passwordForm.valid && this.token) {
      this.message = 'Saving your password...';
      this.authnService.setPassword(this.token, this.passwordForm.controls['password'].value)
        .subscribe({
          next: (v) => {
            this.message = v.message || 'Your password has been set';
            this.messageService.showMessage(this.message, false);
            this.router.navigate(['/auth/signin']);
          },
          error: e => {
            console.error('error', e);
            this.message = e.error?.message || 'Server connection failure';
            this.messageService.showMessage(this.message, true);
          }
        });
    }
  }
}
